<template>
  <div class="main">
    <div class="query-item">
      <div class="search-l">
          <div style="margin-right: 30px;">
            车辆编码
            <a-input class="inp ml10" placeholder="请输入" v-model:value="query.licenceNo"></a-input>
          </div>
          <div style="margin-right: 30px;">
            车辆识别码
            <a-input class="inp ml10" placeholder="请输入" v-model:value="query.vin"></a-input>
          </div>
          <div style="margin-right: 30px;">
            告警类型
            <a-select class="inp ml10" placeholder="请选择" v-model:value="query.type">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="1">超速</a-select-option>
              <a-select-option value="2">越界</a-select-option>
              <a-select-option value="3">闯入禁行区</a-select-option>
              <a-select-option value="4">超区域行驶</a-select-option>
              <a-select-option value="5">急减速</a-select-option>
              <a-select-option :value="6">异常停留</a-select-option>
              <a-select-option :value="7">车辆故障</a-select-option>
            </a-select>
          </div>
          <div style="margin-right: 30px;">
            状态
            <a-select class="inp ml10" placeholder="请选择" v-model:value="query.status">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="0">未处理</a-select-option>
              <a-select-option value="1">已处理</a-select-option>
              <a-select-option value="2">处理中</a-select-option>
              <a-select-option value="3">已忽略</a-select-option>
              <a-select-option value="4">已关闭</a-select-option>
              <a-select-option value="5">已升级</a-select-option>
            </a-select>
          </div>
          <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
          <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
          <a-button class="ml24" @click="openAddModal" type="primary">人工录入</a-button>
      </div>
    </div>

    <a-table :columns="columns" :row-key="(record) => record.id" 
             :data-source="dataSource" size="middle" class="mt23" :pagination="pagination" :scroll="{ y: 'auto' }"
             v-autoHeight="{ extraHeight: 88, trHeight: 47 }" :headerCellStyle="{ textAlign: 'center' }">
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'index'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key === 'licenceNo'">
          {{ record.licenceNo || '-' }}
        </template>
        <template v-if="column.key === 'status'">
          <span class="status-default">{{ getStatusText(record.status) }}</span>
        </template>
        <template  v-if="column.key === 'type'">
          {{ getAlarmType(record.type) }}
        </template>
        <template v-if="column.key === 'occurTime'">
          {{ record.occurTime || '-' }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a @click="viewDetail(record)">查看详情</a>
          </span>
        </template>
      </template>
    </a-table>

    <!-- 人工录入告警弹框 -->
    <a-modal
      v-model:open="addModalVisible"
      title="人工录入告警"
      width="800px"
      @ok="handleAddAlarm"
      @cancel="closeAddModal"
    >
      <a-form :model="addForm" layout="vertical">
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-item label="车辆编码" required>
              <a-select
                v-model:value="vehicleId"
                show-search
                placeholder="请搜索车辆编码"
                :filter-option="false"
                :not-found-content="vehicleFetching ? undefined : null"
                :options="vehicleOptions"
                :field-names="{ label: 'label', value: 'id' }"
                @search="handleVehicleSearch"
                @change="handleVehicleChange"
                allow-clear
              ></a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="测试/运营主体" required>
              <a-input v-model:value="addForm.deptName" placeholder="选择车辆后自动填充" disabled />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="车辆识别码" required>
              <a-input v-model:value="addForm.vehicleVin" placeholder="选择车辆后自动填充" disabled />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="告警类型" required>
              <a-select v-model:value="addForm.type" placeholder="请选择告警类型">
                <a-select-option :value="1">超速</a-select-option>
                <a-select-option :value="2">越界</a-select-option>
                <a-select-option :value="3">闯入禁行区</a-select-option>
                <a-select-option :value="4">超区域行驶</a-select-option>
                <a-select-option :value="5">急减速</a-select-option>
                <a-select-option :value="6">异常停留</a-select-option>
                <a-select-option :value="7">车辆故障</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="告警时间" required>
              <a-date-picker v-model:value="addForm.occurTime" show-time format="YYYY-MM-DD HH:mm" style="width: 100%" />
            </a-form-item>
          </a-col>
        </a-row>

        <a-form-item label="告警信息" required>
          <a-textarea v-model:value="addForm.info" placeholder="请输入告警信息" :rows="4" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import useUserStore from '@/store/modules/user';
import { getAlarmPageList, saveAlarm } from '@/api/alarm/';
import { getVehiclePageList } from '@/api/vehicle/';
import { getStatusText, getAlarmType } from './components/EnumUtils';
import {message} from "ant-design-vue";

const store = useUserStore();
const router = useRouter();

const columns = [
  {
    title: "序号",
    key: "index",
    width: 80,
    align: "center"
  },
  {
    title: "车辆编码",
    dataIndex: "licenceNo",
    key: "licenceNo",
    width: 150,
    align: "center"
  },
  {
    title: "测试/运营主体",
    dataIndex: "deptName",
    key: "deptName",
    width: 150,
    align: "center"
  },
  {
    title: "车辆识别码",
    dataIndex: "vin",
    key: "vin",
    width: 200,
    align: "center"
  },
  {
    title: "触发围栏名称",
    dataIndex: "fenceName",
    key: "fenceName",
    width: 180,
    align: "left"
  },
  {
    title: "告警类型",
    dataIndex: "type",
    key: "type",
    width: 120,
    align: "center"
  },
  {
    title: "状态",
    key: "status",
    width: 100,
    align: "center"
  },
  {
    title: "告警信息",
    dataIndex: "info",
    key: "info",
    align: "left"
  },
  {
    title: "告警时间",
    key: "occurTime",
    width: 180,
    align: "center"
  },
  {
    title: "操作",
    key: "action",
    width: 120,
    align: "center"
  }
];

let dataSource = ref([]);

let query = reactive({
  licenceNo: '',
  vin: '',
  type: '',
  status: ''
});

// 人工录入告警弹框相关
const addModalVisible = ref(false);
const addForm = reactive({
  licenceNo: '',
  deptName: '',
  vehicleVin: '',
  type: undefined,
  alarmLevel: undefined,
  occurTime: null,
  info: ''
});

// 车辆搜索相关
const vehicleOptions = ref([]);
const vehicleFetching = ref(false);
const vehicleId = ref(undefined);
let searchTimer = null;

const handleVehicleSearch = (value) => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(() => {
    fetchVehicleList(value);
  }, 300);
};

const fetchVehicleList = (sk) => {
  if (!sk) {
    vehicleOptions.value = [];
    return;
  }
  vehicleFetching.value = true;
  const data = {
    pageIndex: 1,
    pageSize: 20,
    conditionMap: { sk, dept_id: store.deptId }
  };
  getVehiclePageList(data).then((res) => {
    vehicleOptions.value = (res.data.records || []).map(v => ({
      ...v,
      label: v.licenceNo || v.vin
    }));
  }).finally(() => {
    vehicleFetching.value = false;
  });
};

const handleVehicleChange = (value) => {
  if (value) {
    const vehicle = vehicleOptions.value.find(v => v.id === value);
    if (vehicle) {
      addForm.licenceNo = vehicle.licenceNo || '';
      addForm.deptName = vehicle.deptName || '';
      addForm.vehicleVin = vehicle.vin || '';
    }
  } else {
    addForm.licenceNo = '';
    addForm.deptName = '';
    addForm.vehicleVin = '';
  }
};

const openAddModal = () => {
  addModalVisible.value = true;
  addForm.licenceNo = '';
  addForm.deptName = '';
  addForm.vehicleVin = '';
  addForm.type = undefined;
  addForm.alarmLevel = undefined;
  addForm.occurTime = null;
  addForm.info = '';
  vehicleId.value = undefined;
  vehicleOptions.value = [];
};

const closeAddModal = () => {
  addModalVisible.value = false;
};

const handleAddAlarm = async () => {
  if (!vehicleId.value || !addForm.type || !addForm.occurTime || !addForm.info) {
    message.error('请填写完整信息');
    return;
  }

  try {
    const data = {
      id: null,
      vehicleId: vehicleId.value,
      type: addForm.type,
      occurTime: addForm.occurTime.format('YYYY-MM-DD HH:mm'),
      info: addForm.info
    };
    const res = await saveAlarm(data);
    if (res.code === 200) {
      message.success('告警录入成功');
      closeAddModal();
      await getData();
    }
  } catch (error) {
    console.error('告警录入失败:', error);
    message.error('告警录入失败');
  }
};

const viewDetail = (record) => {
  router.push({ path: '/test/alarm/detail', query: { alarmId: record.id } });
};

const pageChange = (page, pageSize) =>{
  pagination.current = page;
  getData();
}

const pageSizeChange = (current, size) => {
  pagination.pageSize = size;
  getData();
}

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"],
  showTotal: (total) => `共有 ${total} 条数据`,
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize),
  onChange: pageChange,
  showSizeChange: pageSizeChange,
});

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.licenceNo = "";
  query.vin = "";
  query.type = "";
  query.status = "";
  getData();
};

const getData = async () => {
  try {
    const data = {
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
      conditionMap: {
        licenceNo: query.licenceNo,
        vin: query.vin,
        type: query.type,
        status: query.status
      }
    };
    const res = await getAlarmPageList(data);
    if (res.code === 200) {
      dataSource.value = res.data.records || [];
      pagination.total = res.data.total || 0;
    }
  } catch (error) {
    console.error('获取告警列表失败:', error);
    message.error('获取告警列表失败');
  }
};

onMounted(async () => {
  await getData();
});

</script>

<style lang="less" scoped>
.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
    flex-wrap: wrap;
  }
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;
}



.alarm-high {
  color: #F5222D;
  font-weight: 500;
}

.alarm-medium {
  color: #FA8C16;
  font-weight: 500;
}

.alarm-low {
  color: #52C41A;
  font-weight: 500;
}

.alarm-default {
  color: #68767E;
  font-weight: 500;
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #0A212E;
  background-color: #EFEFF5;
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: #68767E;
}

a {
  color: #1E8EF2;
}
</style>